(function () {
  function rafThrottle(fn) {
    let id = 0;
    let args;
    let ctx;
    return function () {
      args = arguments;
      ctx = this;
      if (id) return;
      id = requestAnimationFrame(function () {
        id = 0;
        fn.apply(ctx, args);
      });
    };
  }

  function parseJson(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    if (window.apx && window.apx.Currency && typeof window.apx.Currency.formatMoney === 'function') {
      return window.apx.Currency.formatMoney(cents, format || (window.apx.settings && window.apx.settings.moneyFormat) || window.apx.moneyFormat || '${{amount}}');
    }
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (format && format.indexOf('{{amount}}') > -1) return format.replace('{{amount}}', amount);
    return amount;
  }

  function optionKey(index) {
    const n = Number(index || 0) + 1;
    return 'option' + n;
  }

  function init(el) {
    if (el.getAttribute('data-sticky-initialized') === 'true') return;
    el.setAttribute('data-sticky-initialized', 'true');

    if (!el.hasAttribute('data-portalized')) {
      document.body.appendChild(el);
      el.setAttribute('data-portalized', 'true');
    }

    el.style.display = '';

    const sectionRoot = document.getElementById(el.getAttribute('data-target-id')) || el.closest('.product-section') || document;
    const mainForm = document.getElementById(el.getAttribute('data-main-form-id')) || sectionRoot.querySelector('form[id^="AddToCartForm-"]') || sectionRoot.querySelector('form[action="/cart/add"]') || sectionRoot.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return;

    const behavior = el.getAttribute('data-behavior') || 'add_to_cart';
    const scrollOffsetDesktop = parseFloat(el.getAttribute('data-scroll-offset-desktop') || '120');
    const scrollOffsetMobile = parseFloat(el.getAttribute('data-scroll-offset-mobile') || '90');
    const triggerMode = el.getAttribute('data-trigger-mode') || 'form';
    const triggerPercent = Math.min(100, Math.max(0, parseFloat(el.getAttribute('data-trigger-scroll-percent') || '30')));
    const stickyForm = el.querySelector('form');
    const moneyFormat = el.getAttribute('data-money-format') || '';
    const stickyVariantJson = parseJson(el.querySelector('[data-sticky-variants]'));
    const sectionVariantJson = parseJson(sectionRoot.querySelector('[data-variant-json]'));
    const variants = stickyVariantJson.length ? stickyVariantJson : sectionVariantJson;
    const button = el.querySelector('button[name="add"]');
    const stickyIdField = el.querySelector('[data-sticky-variant-id]') || el.querySelector('input[name="id"]');
    const priceWrap = el.querySelector('[data-sticky-price]');
    const currentPriceEl = el.querySelector('[data-sticky-current-price]');
    const comparePriceEl = el.querySelector('[data-sticky-compare-price]');
    const variantWrap = el.querySelector('.sticky-atc__details__variant');
    const variantTitleEl = el.querySelector('.sticky-atc__details__variant__title');
    const optionSelects = Array.from(el.querySelectorAll('.sticky-atc__select'));
    const imgWrap = el.querySelector('.sticky-atc__image');

    const getVariantIdField = function () {
      return mainForm.querySelector('input[name="id"], select[name="id"]');
    };

    function headerOffset() {
      const h = document.querySelector('.amz-sec-hdr') || document.querySelector('.amz-hdr') || document.querySelector('.section-header') || document.querySelector('.site-header');
      return h ? h.offsetHeight : 0;
    }

    function scrollStopOffset() {
      return window.matchMedia('(min-width: 768px)').matches ? scrollOffsetDesktop : scrollOffsetMobile;
    }

    function scrollToProductForm() {
      const target = mainForm || sectionRoot.querySelector('form[action*="/cart/add"]') || sectionRoot;
      if (!target) return;
      const y = target.getBoundingClientRect().top + window.pageYOffset - scrollStopOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function setBottomOffset() {
      const vv = window.visualViewport;
      let offset = 0;
      if (vv) offset = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
      const prev = parseFloat(el.getAttribute('data-bottom-offset') || '0');
      if (Math.abs(prev - offset) < 2) return;
      el.setAttribute('data-bottom-offset', String(offset));
      el.style.setProperty('--sticky-atc-bottom', offset + 'px');
    }

    function scrollState() {
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const viewportH = window.innerHeight || doc.clientHeight || 0;
      const docH = Math.max(doc.scrollHeight, document.body.scrollHeight);
      const scrollable = Math.max(0, docH - viewportH);
      const progress = scrollable ? (scrollTop / scrollable) * 100 : 100;
      const bottomProgress = docH ? (scrollTop + viewportH) / docH : 0;
      return { progress: progress, bottomProgress: bottomProgress };
    }

    function setFooterHide() {
      const state = scrollState();
      document.documentElement.classList.toggle('scrolled-to-bottom', state.bottomProgress >= 0.9);
    }

    const onScroll = rafThrottle(function () {
      const state = scrollState();
      const rect = mainForm.getBoundingClientRect();
      const hide = triggerMode === 'percent' ? state.progress < triggerPercent : rect.top > headerOffset();
      el.classList.toggle('sticky-atc--out', hide);
      setFooterHide();
      setBottomOffset();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
      window.visualViewport.addEventListener('resize', onScroll);
    }

    function variantById(id) {
      if (!id) return null;
      return variants.find(function (v) {
        return String(v.id) === String(id);
      }) || null;
    }

    function selectedOptionValues() {
      const values = {};
      sectionRoot.querySelectorAll('[data-variant-input]').forEach(function (input) {
        const index = input.getAttribute('data-index') || (input.closest('.variant-input-wrap') && input.closest('.variant-input-wrap').getAttribute('data-index')) || '';
        if (!index) return;
        const type = (input.getAttribute('type') || input.tagName || '').toLowerCase();
        if ((type === 'radio' || type === 'checkbox') && !input.checked) return;
        if (input.value) values[index] = input.value;
      });
      const ordered = Object.keys(values).sort(function (a, b) {
        return parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10);
      }).map(function (key) {
        return values[key];
      });
      if (!ordered.length) {
        optionSelects.forEach(function (sel) {
          if (sel.value) ordered.push(sel.value);
        });
      }
      return ordered;
    }

    function variantByOptions(values) {
      if (!values.length) return null;
      return variants.find(function (v) {
        const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        for (let i = 0; i < values.length; i += 1) {
          if (values[i] && opts[i] !== values[i]) return false;
        }
        return true;
      }) || null;
    }

    function selectedVariant() {
      const idField = getVariantIdField();
      const fromId = idField && idField.value ? variantById(idField.value) : null;
      if (fromId) return fromId;
      return variantByOptions(selectedOptionValues());
    }

    function syncVariantTitle(variant) {
      if (!variantTitleEl) return;
      let txt = '';
      if (variant && variant.options && variant.options.length) txt = variant.options[0] || '';
      if (!txt) {
        const values = selectedOptionValues();
        if (values.length) txt = values[0] || '';
      }
      variantTitleEl.textContent = txt;
      if (variantWrap) variantWrap.hidden = !txt;
    }

    function syncSelectsFromVariant(variant) {
      if (!variant || !variant.options) return;
      optionSelects.forEach(function (sel, index) {
        if (variant.options[index]) sel.value = variant.options[index];
      });
    }

    function syncSelectsFromMain() {
      const values = {};
      sectionRoot.querySelectorAll('[data-variant-input]').forEach(function (input) {
        const index = input.getAttribute('data-index') || (input.closest('.variant-input-wrap') && input.closest('.variant-input-wrap').getAttribute('data-index')) || '';
        if (!index) return;
        const type = (input.getAttribute('type') || input.tagName || '').toLowerCase();
        if ((type === 'radio' || type === 'checkbox') && !input.checked) return;
        if (input.value) values[index] = input.value;
      });
      optionSelects.forEach(function (sel) {
        const idx = optionKey(sel.getAttribute('data-sticky-option-index'));
        if (values[idx]) sel.value = values[idx];
      });
    }

    function updatePrice(variant) {
      if (!priceWrap || !currentPriceEl || !variant) return;
      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);
      const onSale = compare > price;
      currentPriceEl.innerHTML = formatMoney(price, moneyFormat);
      if (comparePriceEl) {
        comparePriceEl.innerHTML = formatMoney(compare, moneyFormat);
        comparePriceEl.hidden = !onSale;
      }
      priceWrap.classList.toggle('sticky-atc__price--sale', onSale);
      priceWrap.classList.toggle('sticky-atc__price--regular', !onSale);
    }

    function buttonText(name, fallback) {
      return button ? button.getAttribute(name) || fallback || '' : fallback || '';
    }

    function updateButton(variant) {
      if (!button) return;
      if (button.getAttribute('data-sticky-busy') === 'true') return;
      const addText = buttonText('data-add-to-cart-text', button.textContent);
      const soldOutText = buttonText('data-sold-out-text', 'Out of stock');
      const unavailableText = buttonText('data-unavailable-text', addText);
      if (!variant) {
        button.textContent = unavailableText;
        button.disabled = true;
        button.classList.add('sticky-atc__btn--sold-out');
        return;
      }
      if (variant.available) {
        button.textContent = addText;
        button.disabled = false;
        button.classList.remove('sticky-atc__btn--sold-out');
      } else {
        button.textContent = soldOutText;
        button.disabled = true;
        button.classList.add('sticky-atc__btn--sold-out');
      }
    }

    function setBusy(isBusy) {
      if (!button) return;
      if (isBusy) {
        const addingText = buttonText('data-adding-text', '');
        button.setAttribute('data-sticky-busy', 'true');
        if (addingText) button.textContent = addingText;
        button.disabled = true;
      } else {
        button.removeAttribute('data-sticky-busy');
        updateButton(selectedVariant());
      }
    }

    function showError(text) {
      const node = el.querySelector('.js-form-error');
      if (!node) return;
      node.textContent = text || el.getAttribute('data-error-text') || (button && button.getAttribute('data-error-text')) || '';
      node.hidden = !node.textContent;
      if (!node.hidden) {
        window.clearTimeout(node.__stickyAtcTimer);
        node.__stickyAtcTimer = window.setTimeout(function () {
          node.hidden = true;
        }, 4000);
      }
    }

    function updateStickyVariantId(variant) {
      if (stickyIdField && variant && variant.id) stickyIdField.value = String(variant.id);
    }

    function updateState(variant) {
      if (!variant) variant = selectedVariant();
      updateStickyVariantId(variant);
      updatePrice(variant);
      updateButton(variant);
      syncVariantTitle(variant);
      syncSelectsFromVariant(variant);
    }

    el.addEventListener('change', function (e) {
      const sel = e.target.closest('.sticky-atc__select');
      if (!sel) return;
      const value = sel.value;
      const targetIndex = optionKey(sel.getAttribute('data-sticky-option-index'));

      sectionRoot.querySelectorAll('[data-variant-input]').forEach(function (input) {
        const index = input.getAttribute('data-index') || (input.closest('.variant-input-wrap') && input.closest('.variant-input-wrap').getAttribute('data-index')) || '';
        if (index !== targetIndex) return;
        const type = (input.getAttribute('type') || input.tagName || '').toLowerCase();
        if (type === 'radio' || type === 'checkbox') {
          if (input.value === value) {
            if (!input.checked) input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          if (input.value !== value) input.value = value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      const variant = variantByOptions(optionSelects.map(function (select) { return select.value; }));
      updateState(variant);
      burstUpdateImg(variant);
      setTimeout(function () {
        syncSelectsFromMain();
        updateState(selectedVariant());
      }, 0);
    });

    let lastSrc = '';

    function getVariantImageSrc(variant) {
      if (!variant) return '';
      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') return variant.featured_image;
        if (variant.featured_image.src) return variant.featured_image.src;
      }
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
      if (variant.image) {
        if (typeof variant.image === 'string') return variant.image;
        if (variant.image.src) return variant.image.src;
      }
      return '';
    }

    function getVariantImageAlt(variant) {
      if (!variant) return '';
      if (variant.featured_image && typeof variant.featured_image !== 'string' && variant.featured_image.alt) return variant.featured_image.alt;
      if (variant.featured_media && variant.featured_media.alt) return variant.featured_media.alt;
      if (variant.title) return variant.title;
      return '';
    }

    function getActiveMainImg() {
      const sels = [
        '.product__main-photos .product-main-slide.is-selected picture img',
        '.product__main-photos .product-main-slide.is-selected img',
        '.product__main-photos [aria-hidden="false"] img',
        '.product__main-photos img',
        '.product__photos img',
        '[data-product-single-media-wrapper][aria-hidden="false"] img',
        '[data-product-single-media-wrapper] img'
      ];
      for (let i = 0; i < sels.length; i += 1) {
        const node = sectionRoot.querySelector(sels[i]);
        if (node && (node.currentSrc || node.src)) return node;
      }
      return null;
    }

    function normalizeSrc(src) {
      if (!src) return '';
      if (src.indexOf('//') === 0) return window.location.protocol + src;
      return src;
    }

    const updateImg = rafThrottle(function (variant) {
      if (!imgWrap) return;
      const selected = variant || selectedVariant();
      const fallbackImg = getActiveMainImg();
      const newSrc = normalizeSrc(getVariantImageSrc(selected) || (!lastSrc && fallbackImg && (fallbackImg.currentSrc || fallbackImg.src)) || '');
      if (!newSrc || newSrc === lastSrc) return;
      let stickyImg = imgWrap.querySelector('img');
      if (!stickyImg) {
        stickyImg = document.createElement('img');
        stickyImg.loading = 'lazy';
        if ('decoding' in stickyImg) stickyImg.decoding = 'async';
        imgWrap.innerHTML = '';
        imgWrap.appendChild(stickyImg);
      }
      stickyImg.alt = getVariantImageAlt(selected) || (fallbackImg && fallbackImg.alt) || '';
      stickyImg.src = newSrc;
      lastSrc = newSrc;
      if (fallbackImg) {
        fallbackImg.addEventListener('load', function () {
          const latest = fallbackImg.currentSrc || fallbackImg.src || '';
          if (!getVariantImageSrc(selected) && latest && latest !== lastSrc) {
            stickyImg.src = latest;
            lastSrc = latest;
          }
        }, { once: true });
      }
    });

    function burstUpdateImg(variant) {
      updateImg(variant);
      setTimeout(function () { updateImg(variant); }, 60);
      setTimeout(function () { updateImg(variant); }, 150);
      setTimeout(function () { updateImg(variant); }, 300);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.product__thumb') || e.target.closest('[data-product-thumb]')) setTimeout(function () { burstUpdateImg(); }, 60);
    });

    mainForm.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('fieldset.variant-input-wrap') || e.target.matches('[data-variant-input]'))) {
        syncSelectsFromMain();
        setTimeout(function () { updateState(selectedVariant()); }, 0);
        burstUpdateImg();
      }
    });

    sectionRoot.addEventListener('variantChange', function (e) {
      const variant = e && e.detail && e.detail.variant ? e.detail.variant : selectedVariant();
      updateState(variant);
      burstUpdateImg(variant);
    });

    document.addEventListener('variant:change', function (e) {
      if (e && e.detail && e.detail.sectionId) {
        const thisId = sectionRoot.getAttribute('data-section-id') || sectionRoot.dataset.sectionId;
        if (thisId && String(e.detail.sectionId) !== String(thisId)) return;
      }
      const variant = e && e.detail && e.detail.variant ? e.detail.variant : selectedVariant();
      updateState(variant);
      burstUpdateImg(variant);
    });

    const idField = getVariantIdField();
    if (idField && 'MutationObserver' in window) {
      new MutationObserver(function () {
        updateState(selectedVariant());
      }).observe(idField, { attributes: true, attributeFilter: ['value'] });
    }

    const gallery = sectionRoot.querySelector('.product__main-photos') || sectionRoot;
    if ('MutationObserver' in window && gallery) {
      new MutationObserver(function () { burstUpdateImg(); }).observe(gallery, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'srcset', 'data-current', 'data-media-id', 'aria-hidden', 'style']
      });
    }

    function submitMain(variantId) {
      let idField = getVariantIdField();
      if (!idField) {
        idField = document.createElement('input');
        idField.type = 'hidden';
        idField.name = 'id';
        mainForm.appendChild(idField);
      }
      if (variantId) idField.value = String(variantId);
      setBusy(true);
      const btn = mainForm.querySelector('button[name="add"]');
      if (typeof mainForm.requestSubmit === 'function') {
        try {
          if (btn) btn.disabled = false;
          mainForm.requestSubmit(btn || null);
        } catch (e) {
          btn ? btn.click() : mainForm.submit();
        }
      } else if (btn) {
        btn.click();
      } else {
        mainForm.submit();
      }
      setTimeout(function () {
        setBusy(false);
        const html = document.documentElement;
        const drawer = document.getElementById('CartDrawer') || document.querySelector('[id*="CartDrawer"]');
        const isOpen = html.classList.contains('js-drawer-open') || (drawer && drawer.classList.contains('is-open')) || (drawer && drawer.getAttribute('aria-hidden') === 'false');
        if (!isOpen && drawer) {
          drawer.classList.add('is-open');
          html.classList.add('js-drawer-open', 'js-drawer-open-right');
        }
      }, 800);
    }

    function onStickySubmit(e) {
      if (behavior === 'scroll') {
        e.preventDefault();
        scrollToProductForm();
        return;
      }
      e.preventDefault();
      const variant = selectedVariant();
      if (!variant || !variant.available) {
        const text = !variant ? buttonText('data-unavailable-text', el.getAttribute('data-error-text')) : buttonText('data-sold-out-text', el.getAttribute('data-error-text'));
        showError(text);
        scrollToProductForm();
        return;
      }
      submitMain(variant.id);
    }

    if (stickyForm) stickyForm.addEventListener('submit', onStickySubmit);

    el.addEventListener('click', function (e) {
      const scrollLink = e.target.closest('.sticky-atc__buttons a');
      if (!scrollLink || behavior !== 'scroll') return;
      e.preventDefault();
      scrollToProductForm();
    });

    syncSelectsFromMain();
    updateState(selectedVariant());
    burstUpdateImg();
    setBottomOffset();
    setFooterHide();
    requestAnimationFrame(onScroll);
  }

  function initAll() {
    const seen = new Set();
    document.querySelectorAll('sticky-atc').forEach(function (el) {
      const key = el.getAttribute('data-target-id') || 'global';
      if (seen.has(key)) {
        el.remove();
        return;
      }
      seen.add(key);
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') initAll();
})();
